import type { Story } from '@/store/story-types'

export const AI_SAAS_LANDING_STORY: Story = {
  id: 'ai-saas-landing-1',
  name: 'AI SaaS Landing',
  narrative: 'A modern AI SaaS landing page that introduces the product with a live demo, highlights AI-powered features, and presents pricing tiers to convert visitors into paying users.',
  goals: ['Introduce AI product', 'Demonstrate capabilities', 'Highlight features', 'Present pricing', 'Convert sign-ups'],
  lifecycle: 'building',
  pages: [
    { id: 'pg-home', title: 'Home', order: 0, status: 'draft', elementCount: 5, linkedPageId: 'ai-home', description: 'Single-page SaaS landing with navbar, hero, features, demo, and pricing',
      blockRef: { category: 'saas', blockId: 'ai-hero' } },
  ],
  bddScenarios: [
    {
      id: 'bdd-1',
      name: 'View Hero',
      description: 'Visitor sees the AI product hero section',
      steps: [
        { type: 'given', text: 'the visitor opens the landing page' },
        { type: 'when', text: 'the page loads' },
        { type: 'then', text: 'the hero headline, subtitle, and primary CTA button are visible', linkedPageId: 'ai-home' },
      ],
    },
    {
      id: 'bdd-2',
      name: 'Explore Features',
      description: 'Visitor browses the AI feature highlights',
      steps: [
        { type: 'given', text: 'the visitor is on the landing page' },
        { type: 'when', text: 'they scroll to the features section' },
        { type: 'then', text: 'feature cards with AI capabilities and icons are displayed', linkedPageId: 'ai-home' },
      ],
    },
    {
      id: 'bdd-3',
      name: 'Try Demo',
      description: 'Visitor interacts with the live product demo',
      steps: [
        { type: 'given', text: 'the visitor is on the landing page' },
        { type: 'when', text: 'they scroll to the demo section' },
        { type: 'then', text: 'an interactive demo or preview of the AI product is shown', linkedPageId: 'ai-home' },
      ],
    },
    {
      id: 'bdd-4',
      name: 'Compare Pricing',
      description: 'Visitor compares pricing tiers',
      steps: [
        { type: 'given', text: 'the visitor wants to see pricing' },
        { type: 'when', text: 'they scroll to the pricing section' },
        { type: 'then', text: 'pricing tiers with features and CTA buttons are displayed', linkedPageId: 'ai-home' },
      ],
    },
    {
      id: 'bdd-5',
      name: 'Sign Up',
      description: 'Visitor signs up for the AI product',
      steps: [
        { type: 'given', text: 'the visitor clicks a Get Started CTA' },
        { type: 'when', text: 'the sign-up flow begins' },
        { type: 'then', text: 'a sign-up form or redirect to onboarding is presented', linkedFlowId: 'signUpAi' },
      ],
    },
  ],
}
